





































































































































































































































































































































































































































































import { Component, Prop, Vue, Mixins } from 'vue-property-decorator';
import {
  default_settings,
  default_track,
  default_layout,
  default_keymap,
} from '@/defaults';

import Player from '@/components/Player.vue';
import VideoModal from '@/components/VideoModal.vue';
import TrackModal from '@/components/TrackModal.vue';
import TagModal from '@/components/TagModal.vue';
import TrackSelectModal from '@/components/TrackSelectModal.vue';
import LayoutModal from '@/components/LayoutModal.vue';
import ShareModal from '@/components/ShareModal.vue';
import AuthMixin from '@/mixins/AuthMixin';

import { ListLoader } from 'vue-content-loader';

import _get from 'lodash.get';
import _orderBy from 'lodash.orderby';
import _debounce from 'lodash.debounce';
import _keyBy from 'lodash.keyby';

import { generateTagId, makeId } from '@/utils/makeId';
import { fromSeconds } from '@/utils/timeFormat';
import { divideDistribute } from '@/utils/number';
import { urlMediaType, truncate } from '@/utils/text';
import { tagParser, tagBuilder } from '@/utils/tagParser';
import { GET_AUTHENTICATED } from '../store/modules/auth/types';
import { SET_VIDEO_STORE } from '../store/modules/video/types';

@Component({
  components: {
    Player,
    ListLoader,
  },
})
export default class Video extends Mixins(AuthMixin) {
  loading = true;

  unsaved_changes = 0;
  unsubscribe: any = {
    auth: () => {},
  };

  linked_id: string | null = null;
  linked_authorized: boolean = false;

  interface_open: boolean = true;
  mouseover_tagging: boolean = false;
  layout: any = {
    ...default_layout,
  };
  route_data: string = '';
  route_query: any = {};

  time: number = 0;

  video: any = {
    name: '',
    type: '',
    id: '',
    settings: {
      ...default_settings,
    },
  };

  tab: number = this.tabIndex(this.video.settings.default_tab);

  tracks: any = [];
  tracks_index: any = {};

  tags: any = [];
  state: any = {
    resumed: false,
    triggered_seeked: false,
    seeked: false,
    tag: null,
    track: null,
    tagging: {},
    tagging_history: [],
  };
  active: any = {
    tracks: [],
    tagging_tracks: [],
    autoplay_next_tag: false,
  };

  get player() {
    return (this.$refs.video as any).player;
  }

  get authorized() {
    return (this.linked_id && this.linked_authorized) || !this.linked_id;
  }

  async authorize() {
    const { authorized } = await this.auth(this.linked_id);
    if (authorized) {
      this.linked_authorized = true;
      this.initLayout();
      this.$buefy.toast.open('Successfully logged in.');
    }
  }

  tabIndex(tab_name: string | (string | null)[]) {
    let _tab_name = tab_name;

    if (Array.isArray(_tab_name)) {
      _tab_name = _tab_name[_tab_name.length - 1] || '';
    }

    switch (_tab_name) {
      case 'tracks':
        return 1;
      case 'tags':
      default:
        return 0;
    }
  }

  triggerUnsavedChanges(cb: any) {
    this.$buefy.dialog.confirm({
      title: 'Unsaved Changes',
      message:
        'You have unsaved changed. Are you sure you want to leave page and discard changes?',
      confirmText: 'Leave',
      type: 'is-warning',
      hasIcon: true,
      onConfirm: () => {
        cb();
      },
      onCancel: () => {
        cb(false);
      },
    });
  }

  created() {
    if (this.$route.params.type === 'id') {
      this.linked_id = this.$route.params.id;
      this.video.type = this.$route.params._type;
      this.video.id = this.$route.params._id;
      this.route_data = this.$route.params._pathMatch;
      this.route_query = this.$route.query;
      this.linked_authorized = this.$route.params._authorized as any;
      this.initPreMount();
    } else {
      this.video.type = this.$route.params.type;
      this.video.id = this.$route.params.id;
      this.route_data = this.$route.params.pathMatch;
      this.route_query = this.$route.query;
      this.initPreMount();
    }
  }

  mounted() {
    this.unsubscribe.auth = this.$store.watch(
      () => this.$store.getters[`auth/${GET_AUTHENTICATED}`],
      (authenticated) => {
        if (!authenticated) {
          this.linked_authorized = false;
        }
        this.initLayout();
      }
    );

    window.addEventListener('keyup', this.initKeyboard);
    window.addEventListener('beforeunload', this.initUnload);

    this.player.off('ready', this.playerReadyEvent);
    this.player.on('ready', this.playerReadyEvent);
  }

  beforeRouteLeave(to: any, from: any, next: any) {
    if (this.linked_id && this.authorized && this.unsaved_changes) {
      this.triggerUnsavedChanges(next);
    } else {
      next();
    }
  }

  playerReadyEvent(event: any) {
    // hack for mute sound issue
    if (this.video.type === 'youtube') {
      setTimeout(() => {
        // this.player.currentTime = 0;
        // this.player.muted = false;
        this.player.play();
        this.player.pause();
        this.state.resumed = false;
      }, 100);
    }

    this.initData(
      this.video.type,
      this.video.id,
      this.route_data,
      this.route_query
    );

    this.loading = false;

    this.player.off('timeupdate', this.timeUpdateDebounced);
    this.player.on('timeupdate', this.timeUpdateDebounced);

    this.player.off('seeked', this.playerSeekedEvent);
    this.player.on('seeked', this.playerSeekedEvent);

    this.player.off('play', this.playerPlayEvent);
    this.player.on('play', this.playerPlayEvent);

    this.player.off('pause', this.playerPauseEvent);
    this.player.on('pause', this.playerPauseEvent);

    this.player.off('ended', this.playerEndedEvent);
    this.player.on('ended', this.playerEndedEvent);
    // this.player.off('canplay', () => {};
    // this.player.on('canplay', () => {
    //   console.log('canplay');
    // });
  }

  playerSeekedEvent() {
    this.state.seeked = true;
  }

  playerPlayEvent() {
    this.state.triggered_seeked = false;
    this.state.resumed = true;
  }

  playerPauseEvent() {
    this.state.tagging_history = [];
  }

  playerEndedEvent() {
    this.state.tagging_history = [];
  }

  initPreMount() {
    if (this.video.type === 'source') {
      this.video.id = decodeURIComponent(this.video.id);
      const source_media_type: string = urlMediaType(this.video.id);
      if (source_media_type) {
        this.video.media_type = source_media_type;
      }
      this.video.media_type = 'video/mp4';
    }
  }

  initData(provider: string, id: string, data: any, options: any = {}) {
    if (['youtube', 'vimeo', 'source'].indexOf(provider) > -1) {
      const { video, tracks, tags, query } = tagParser(data, options, {
        duration: this.player.duration,
      });

      this.video = { ...this.video };

      this.video.name = decodeURIComponent(
        video.name || _get(this.player, 'config.title', '')
      );

      this.video.settings = {
        ...this.video.settings,
        ...video.settings,
      };

      this.tracks = [{ ...default_track }, ...tracks];
      this.tags = tags;

      this.route_query = query;

      this.initTitle();
      this.initVideo();
      this.initSettings();
      this.initLayout();
      this.updateData();
    }
  }

  initTitle() {
    if (this.video.name) {
      document.title = `${truncate(this.video.name, 65)} - Video | ${
        process.env.VUE_APP_NAME
      }`;
    }
  }

  initVideo() {
    if (!this.video.name) {
      this.video.name = _get(this.player, 'config.title', '');
      this.initTitle();
      setTimeout(() => {
        this.video.name = _get(this.player, 'config.title', '');
        this.initTitle();
      }, 2000);
    }
  }

  initSettings() {
    this.tracks[0].name = this.video.settings.default_track_name;
    this.tracks[0].color = this.video.settings.default_track_color;
    this.tracks[0].note = this.video.settings.default_track_note;
    this.tracks[0].default_tag_duration = this.video.settings.default_tag_duration;
    this.tracks[0].default_tag_lag_time = this.video.settings.default_tag_lag_time;
  }

  initLayout() {
    this.tab = this.tabIndex(this.video.settings.default_tab);

    for (const [key, value] of Object.entries(this.layout || {})) {
      if (typeof this.route_query[key] !== 'undefined') {
        this.layout[key] = this.route_query[key];
      }
    }

    if (!this.layout.show_tags) {
      this.tab = 1;
    } else if (!this.layout.show_tracks) {
      this.tab = 0;
    }

    if (!this.authorized) {
      this.layout.show_controls = false;
    } else {
      if (typeof this.route_query.show_controls !== 'undefined') {
        this.layout.show_controls = this.route_query.show_controls;
      } else {
        this.layout.show_controls = true;
      }
    }
  }

  initKeyboard(event: any) {
    if (this.mouseover_tagging) {
      let key;

      // https://stackoverflow.com/a/35395154
      if (event.key !== undefined) {
        key = event.key;
      } else if (event.keyCode !== undefined) {
        key = event.keyCode;
      }

      if (default_keymap.hasOwnProperty(key)) {
        if (default_keymap[key] >= 0 && default_keymap[key] <= 9) {
          if (this.activeTaggingTracks[default_keymap[key]]) {
            this.createTag(this.activeTaggingTracks[default_keymap[key]]);
          }
        }

        if (
          default_keymap[key] === 'undo' &&
          this.state.tagging_history.length > 0
        ) {
          const [track_id, tag] = this.state.tagging_history.pop();
          if (tag && tag.id) {
            const index = this.tags.indexOf(tag);
            if (index > -1) {
              this.tags.splice(index, 1);
              if (this.video.settings.tagging_mode === 'manual') {
                if (this.state.tagging[track_id]) {
                  this.$set(this.state.tagging, track_id, null);
                }
              }
              this.updateData(true);
            }
          }
        }
      }
    }
  }

  initUnload(event: any) {
    if (this.linked_id && this.authorized && this.unsaved_changes) {
      event.returnValue =
        'You have unsaved changed. Are you sure you want to leave page and discard changes?';
    }
  }

  updateData(saveable?: boolean) {
    if (saveable) {
      this.unsaved_changes++;
    }
    this.tags = _orderBy(this.tags, ['start'], ['asc']);
    this.tracks_index = _keyBy(this.tracks, 'id');
    this.updateUrl();
  }

  timeUpdateDebounced = _debounce(this.timeUpdate, 250, { maxWait: 500 });

  timeUpdate() {
    this.time = this.player && this.player.currentTime;

    // console.log(this.player.currentTime, this.state.tag);

    let time;
    let pause = false;

    if (this.state.seeked) {
      this.state.seeked = false;
      if (!this.state.triggered_seeked) {
        time = this.time;
      }
      this.state.triggered_seeked = false;
    }

    if (this.state.tag) {
      if (
        this.time >=
        (this.state.tag.end ||
          this.state.tag.start + this.video.settings.default_tag_duration)
      ) {
        if (
          this.video.settings.autoplay_next_tag ||
          this.active.autoplay_next_tag
        ) {
          this.state.tag = this.nextTag(this.state.tag, time);
          if (this.state.tag) {
            this.playVideo(this.state.tag.start);
          } else {
            this.active.autoplay_next_tag = false;
            if (!this.video.settings.continue_last_tag) {
              pause = true;
            }

            if (this.state.track) {
              if (this.video.settings.autoplay_next_track) {
                this.state.track = this.nextTrack(this.state.track);
                if (this.state.track) {
                  pause = false;
                  this.playTags();
                } else {
                  pause = true;
                }
              }
            }
          }
        } else {
          if (this.state.resumed) {
            this.playVideo(this.state.tag.start);
          } else {
            pause = true;
          }
        }
      }
    }

    if (pause) {
      if (this.video.settings.loop) {
        this.loopVideo();
      } else {
        this.player.pause();
      }
    }

    if (this.state.resumed) {
      this.state.resumed = false;
    }

    //     :class="{
    //   active:
    //     time >= props.row.start &&
    //     time <=
    //       (props.row.end ||
    //         props.row.start + default_duration),
    // }"
  }

  filterTagsByTrack(track: any) {
    return this.tags
      .filter((tag: any) => {
        if (track.id === 'trackless') {
          return tag.track.length === 0;
        } else {
          return tag.track.indexOf(track.id) > -1;
        }
      })
      .map((tag: any) => {
        tag._track_colors = this.tagColors(tag);
        return tag;
      });
  }

  filterTagsByTracks(tracks: any[]) {
    let tags;
    if (tracks.length === 0 || tracks.length === this.tracks.length) {
      tags = this.tags;
    } else {
      tags = this.tags.filter((tag: any) => {
        let matches = 0;
        for (const track of tracks) {
          if (track.id === 'trackless') {
            if (tag.track.length === 0) {
              matches++;
            }
          } else {
            if (tag.track.indexOf(track.id) > -1) {
              matches++;
            }
          }
        }
        return matches > 0;
      });
    }

    return tags.map((tag: any) => {
      tag._track_colors = this.tagColors(tag);
      return tag;
    });
  }

  get groupedTracks() {
    return this.tracks.map((track: any) => {
      return {
        ...track,
        tags: this.filterTagsByTrack(track),
      };
    });
  }

  // OPTIMISE: Can be made faster by breaking this up
  get activeTags() {
    if (this.tab === 0) {
      return this.filterTagsByTracks(this.active.tracks || []);
    } else {
      return this.filterTagsByTrack(this.state.track || []);
    }
  }

  get activeTaggingTracks() {
    if (this.active.tagging_tracks.length === 0) {
      return this.tracks;
    } else {
      return this.active.tagging_tracks;
    }
  }

  previousTag(tag?: any, time?: number) {
    let index = this.activeTags.indexOf(tag || this.state.tag);
    let ret = null;

    if (index > -1) {
      ret = this.activeTags[index - 1] || null;
    }

    return ret;
  }

  nextTag(tag?: any, time?: number) {
    let index = this.activeTags.indexOf(tag || this.state.tag);
    let ret = null;

    if (index > -1) {
      // ret = this.activeTags[index + 1] || null;
      for (let i = index + 1; i < this.activeTags.length; i++) {
        if (time) {
          if (this.activeTags[i].start >= time) {
            ret = this.activeTags[i] || null;
            break;
          }
        } else {
          ret = this.activeTags[i] || null;
          break;
        }
      }
    }

    return ret;
  }

  nextTrack(track?: any) {
    let index = this.groupedTracks.indexOf(track || this.state.track);
    let ret = null;

    if (index > -1) {
      for (let i = index + 1; i < this.groupedTracks.length; i++) {
        if (
          this.groupedTracks[i] &&
          this.groupedTracks[i].tags &&
          this.groupedTracks[i].tags.length > 0
        ) {
          ret = this.groupedTracks[i];
          break;
        }
      }

      // ret = this.groupedTracks[index + 1] || null;
    }

    return ret;
  }

  currentTime(time: number) {
    if (this.video.type === 'vimeo') {
      this.player.embed.setCurrentTime(time);
    } else {
      this.player.currentTime = time;
    }
  }

  playVideo(start: number) {
    this.state.triggered_seeked = true;
    this.currentTime(start);
    // this.player.currentTime = start;
    if (!this.player.playing) {
      // this.player.muted = !!this.player.muted;
      this.player.play();
    }
  }

  loopVideo() {
    if (this.tab === 0) {
      this.playTags();
    } else {
      if (this.state.track) {
        this.playTrack(this.state.track);
      } else {
        this.playTrack(this.nextTrack(this.groupedTracks[0]));
      }
    }
  }

  stopVideo() {
    this.state.tag = null;
    this.state.track = null;
    this.active.autoplay_next_tag = false;
    this.time = 0;

    if (this.player.currentTime !== 0) {
      this.player.currentTime = 0;
    }

    if (!this.player.paused) {
      this.player.pause();
    }
  }

  playTag(tag?: any) {
    this.state.tag = tag || this.activeTags[0];
    if (this.state.tag) {
      this.playVideo(this.state.tag.start);
    }
  }

  playTags() {
    this.active.autoplay_next_tag = true;
    this.playTag();
  }

  playPreviousTag() {
    this.playTag(this.previousTag());
  }

  playNextTag() {
    this.playTag(this.nextTag());
  }

  playTrack(track?: any) {
    this.state.track = track || this.groupedTracks[0];
    this.playTags();
  }

  playTrackTag(track: any, tag: any) {
    this.state.track = track;
    this.playTag(tag);
  }

  playPreviousTrackTag(track: any) {
    this.state.track = track;
    this.playTag(this.previousTag());
  }

  playNextTrackTag(track: any) {
    this.state.track = track;
    this.playTag(this.nextTag());
  }

  tabChange(index: number) {
    return;
    // this.stopVideo();
  }

  createTag(track: any) {
    if (!this.player.playing && !this.time) {
      this.player.play();
      this.$buefy.toast.open('Video started, ready to tag.');
      return;
    }

    if (this.video.settings.tagging_mode === 'manual') {
      if (this.state.tagging[track.id]) {
        if (this.state.tagging[track.id].start < this.time) {
          this.state.tagging[track.id].end = this.time;
        }
        this.$set(this.state.tagging, track.id, null);
        this.updateData(true);
        return;
      }
    }

    const id = generateTagId(this.tags);

    let start_time =
      this.time -
      (track.tag_lag_time || this.video.settings.default_tag_lag_time);

    if (start_time < 0) {
      start_time = 0;
    }

    let end_time =
      this.time +
      (track.tag_duration || this.video.settings.default_tag_duration);

    if (end_time > this.player.duration) {
      end_time = this.player.duration;
    }

    const tag = {
      id: `tag_${id}`,
      start: start_time,
      end: end_time,
      track: track.id === 'trackless' ? [] : [track.id],
    };

    this.tags.push(tag);
    this.state.tagging_history.push([track.id, tag]);

    if (this.video.settings.tagging_mode === 'manual') {
      this.$set(this.state.tagging, track.id, tag);
    }

    this.updateData(true);
  }

  openVideoModal(mode: string, video: any = {}) {
    this.$buefy.modal.open({
      parent: this,
      component: VideoModal,
      hasModalCard: true,
      canCancel: ['escape', 'outside'],
      props: {
        linked_id: this.linked_id,
        mode,
        video,
        video_name: _get(this.player, 'config.title', ''),
      },
      events: {
        save: (data: any) => {
          this.video.name = data.name;
          this.video.settings = data.settings;

          if (this.video.id !== data.id) {
            this.video.id = data.id;
            this.stopVideo();
            if (this.video.type === 'source') {
              this.player.source = {
                type: 'video',
                sources: [
                  {
                    src: this.video.id,
                    type: urlMediaType(this.video.id),
                  },
                ],
              };
            } else {
              this.video.name = '';
              this.player.source = {
                type: 'video',
                sources: [
                  {
                    src: this.video.id,
                    provider: this.video.type,
                  },
                ],
              };
            }
          } else {
            this.initVideo();
            this.updateData(true);
          }
        },
      },
    });
  }

  openTrackModal(mode: string, track: any = {}) {
    this.$buefy.modal.open({
      parent: this,
      component: TrackModal,
      hasModalCard: true,
      canCancel: ['escape', 'outside'],
      props: {
        mode,
        video: this.video,
        tracks: this.tracks,
        tags: this.tags,
        track,
        duration: this.player.duration,
      },
      events: {
        remove: () => {
          if (this.state.track === track) {
            this.state.track = this.nextTrack();
          }
          this.updateData(true);
        },
        create: () => {
          this.updateData(true);
        },
        duplicate: () => {
          this.updateData(true);
        },
        clone: () => {
          this.updateData(true);
        },
        save: (data: any) => {
          if (track.id === 'trackless') {
            this.video.settings.default_track_name = data.name;
            this.video.settings.default_track_color = data.color;
            this.video.settings.default_track_note = data.note;
            this.video.settings.default_tag_duration = data.tag_duration;
            this.video.settings.default_tag_lag_time = data.tag_lag_time;
          }

          this.updateData(true);
        },
      },
    });
  }

  openTagModal(mode: string, tag: any = {}, track?: any) {
    this.$buefy.modal.open({
      parent: this,
      component: TagModal,
      hasModalCard: true,
      canCancel: ['escape', 'outside'],
      props: {
        mode,
        video: this.video,
        tracks: this.tracks,
        track: track,
        tags: this.tags,
        tag,
        duration: this.player.duration,
        time: this.time,
      },
      events: {
        remove: () => {
          if (this.state.tag === tag) {
            this.state.tag = this.nextTag();
          }
          this.updateData(true);
        },
        create: () => {
          this.updateData(true);
        },
        duplicate: () => {
          this.updateData(true);
        },
        save: () => {
          this.updateData(true);
        },
      },
    });
  }

  openTrackSelectModal() {
    this.$buefy.modal.open({
      parent: this,
      component: TrackSelectModal,
      hasModalCard: true,
      canCancel: ['escape', 'outside'],
      props: {
        tracks: this.tracks,
        active: this.active,
      },
      events: {
        done: (data: any) => {
          this.active.tracks = data;
        },
      },
    });
  }

  openActiveTrackSelectModal() {
    this.$buefy.modal.open({
      parent: this,
      component: TrackSelectModal,
      hasModalCard: true,
      canCancel: ['escape', 'outside'],
      props: {
        tracks: this.tracks,
        active: this.active.tagging_tracks,
      },
      events: {
        done: (data: any) => {
          this.active.tagging_tracks = data;
        },
      },
    });
  }

  openLayoutModal() {
    this.$buefy.modal.open({
      parent: this,
      component: LayoutModal,
      hasModalCard: true,
      canCancel: ['escape', 'outside'],
      props: {
        authorized: this.authorized,
        query: this.route_query,
        layout: this.layout,
      },
      events: {
        done: (data: any) => {
          this.layout = data;

          for (const [key, value] of Object.entries(this.layout || {})) {
            this.route_query[key] = this.layout[key];
          }

          if (!this.authorized) {
            delete this.route_query.show_controls;
          }

          this.initLayout();
          this.updateData();
        },
      },
    });
  }

  openShareModal() {
    this.$buefy.modal.open({
      parent: this,
      component: ShareModal,
      hasModalCard: true,
      canCancel: ['escape', 'outside'],
      props: {
        unsaved_changes: this.unsaved_changes,
        linked_id: this.linked_id,
        video: this.video,
        tracks: this.tracks,
        tags: this.tags,
        query: this.route_query,
        layout: this.layout,
        data: {
          name: _get(this.player, 'config.title', ''),
        },
      },
      events: {
        done: (data: any) => {
          this.unsaved_changes = data.unsaved_changes;
          this.linked_id = data.linked_id;
          if (data.authorized) {
            this.linked_authorized = true;
          }
        },
      },
    });
  }

  updateUrl() {
    const { path_string, query_string, query_object } = tagBuilder(
      this.video,
      this.tracks,
      this.tags,
      this.route_query,
      {
        name: _get(this.player, 'config.title', ''),
      }
    );

    let id = this.video.id;
    let type = this.video.type;

    if (this.video.type === 'source') {
      id = encodeURIComponent(this.video.id);
    }

    this.route_data = path_string;

    let link: string;

    if (this.linked_id) {
      type = 'id';
      id = this.linked_id;
      link = `/video/id/${this.linked_id}${query_string}`;
      window.history.replaceState({}, document.title, link);
    } else {
      link = `/video/${this.video.type}/${id}/${path_string}${query_string}`;
      window.history.replaceState({}, document.title, link);
    }

    this.$store.dispatch(`video/${SET_VIDEO_STORE}`, {
      type,
      id,
      data: decodeURIComponent(path_string),
      query: query_object,
    });
  }

  tagColors(tag: any) {
    if (!tag.track || tag.track.length === 0) {
      return {
        background: `linear-gradient(to right, ${this.video.settings.default_track_color} 0%, ${this.video.settings.default_track_color} 100%)`,
      };
    } else {
      const colors = [];
      const stops = divideDistribute(100, tag.track.length);
      let stop = 0;

      for (let i = 0; i < tag.track.length; i++) {
        colors.push(`${this.tracks_index[tag.track[i]].color} ${stop}%`);
        stop += stops[i];
        colors.push(`${this.tracks_index[tag.track[i]].color} ${stop}%`);
      }

      // for (const track of tag.track) {
      //   colors.push(`${this.tracks_index[track].color} ${stops}%`);
      //   stops += increment;
      //   colors.push(`${this.tracks_index[track].color} ${stops}%`);
      // }

      return {
        background: `linear-gradient(to right, ${colors.join(',')})`,
      };
    }
  }

  beforeDestroy() {
    this.unsubscribe.auth();
    try {
      window.removeEventListener('keyup', this.initKeyboard);
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error(e);
    }

    try {
      window.removeEventListener('beforeunload', this.initUnload);
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error(e);
    }
  }
}
